<template>
  <div class="form" style="text-align:left;">
    <div class="title is-4">{{ title }}</div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Key">
          <b-input maxlength="255" v-model="item.key"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Property">
          <VueTrix v-if="renderAsHtml(item.key)" maxlength="255" v-model="item.property" placeholder=""/>
          <b-input v-else type="textarea" v-model="item.property"></b-input>
        </b-field>
      </div>

    </div>


    <div class="columns">
      <div class="column">
        <b-button type="is-primary" v-on:click="save()" :disabled="loading">Speichern</b-button>
      </div>
    </div>

  </div>
</template>


<script>
// @ is an alias to /src

import Vue from 'vue'
import VueTrix from "vue-trix";

const axios = require('axios');


export default {
  name: "SingleUser",
  components: {
    VueTrix,
  },
  data() {
    return {
      title: "Neuen Konfiguration anlegen",
      item: {},
      loading: true,
      //  item: { 'id': 22, 'name': 'Beidseitig individuelles Kartenset', 'spielart': 'Kartenspiel', 'date': '2016-10-15 13:43:27' },
    }
  },
  watch: {},
  mounted: function () {
    console.log("FORM " + this.$route.params.id);
    if (this.$route.params.id) {
      this.title = "Konfiguration bearbeiten";
      //Get-Game
      var _this = this;
      axios.get('/api/configuration/' + this.$route.params.id, {
        withCredentials: true,
      })
          .then(function (response) {
            console.log(response.data);
            _this.item = response.data;
            _this.loading = false;

          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            // always executed
          });
    } else {
      this.loading = false;
    }

  },
  methods: {
    renderAsHtml: function (key) {
      return key ===  "mail.offer.body"
    },
    save: function () {
      //Set-Package
      var _this = this;
      var url = '/api/configuration';


      console.log("SAVE");
      console.log(url);
      console.log(this.item);

      axios.post(url, this.item, {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      })
          .then(function (response) {
            console.log(response.data);
            _this.$router.push({name: 'configuration'})
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            // always executed
          });


    }
  }
};

</script>
